import { Component, Input } from '@angular/core';
import { Company } from '../../interfaces/company';
import { backendServerUrl } from '../../../environments/environment';

@Component({
    selector: 'app-company-logo',
    standalone: false,
    templateUrl: './company-logo.component.html',
    styleUrl: './company-logo.component.scss'
})
export class CompanyLogoComponent {
    @Input({ required: true }) public company!: Company;

    protected backendServerUrl = backendServerUrl;
}

